module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"accountInfo":"Информация об аккаунте","settings":"Настройки"}}')
  delete Component.options._Ctor
}
